export default __webpack_public_path__ + "e79ac935ed65bbaee6862682f3127af3.svg";